import { format, parseISO } from 'date-fns';

export function formatDate(date: string | Date | undefined, formatText: string = 'MMM dd, yyyy') {
  if (!date) {
    return '';
  }
  const dateFormatted = format(typeof date === 'string' ? parseDate(date) : date, formatText);
  if (dateFormatted === 'Invalid Date') {
    return '';
  }
  return dateFormatted;
}

export function parseDate(date: string = ''): Date {
  return parseISO(date);
}

export const monthToShortMonth = (month: number) => {
  const date = new Date(0, month, 0);
  if (date instanceof Date && !isNaN(date.getTime())) {
    return date.toLocaleString('en-US', { month: 'short' });
  }
  throw new Error('Invalid Date');
};
